import React from "react";
import { Box, Typography, Button } from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { useNavigate } from "react-router-dom";
import { usePermissions } from "../../Core/Permissions";

interface PermissionGuardProps {
  module: string;
  action?: "can_view" | "can_create" | "can_edit" | "can_delete";
  children: React.ReactNode;
}

const UnauthorizedView = () => {
  const navigate = useNavigate();
  return (
    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: "60vh", gap: 2 }}>
      <Box sx={{ width: 64, height: 64, borderRadius: "50%", bgcolor: "#fef2f2", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <LockOutlinedIcon sx={{ fontSize: 32, color: "#ef4444" }} />
      </Box>
      <Typography sx={{ fontWeight: 800, fontSize: 20, color: "#1e293b" }}>Access Denied</Typography>
      <Typography sx={{ fontSize: 14, color: "#64748b", textAlign: "center", maxWidth: 400 }}>
        You do not have permission to access this module. Contact your administrator to request access.
      </Typography>
      <Button variant="contained" onClick={() => navigate("/dashboard/list")}
        sx={{ mt: 1, textTransform: "none", fontWeight: 700, bgcolor: "#2f3891", "&:hover": { bgcolor: "#252d73" } }}>
        Go to Dashboard
      </Button>
    </Box>
  );
};

const PermissionGuard: React.FC<PermissionGuardProps> = ({ module, action = "can_view", children }) => {
  const { hasPermission } = usePermissions();

  if (!hasPermission(module, action)) {
    return <UnauthorizedView />;
  }

  return <>{children}</>;
};

export default PermissionGuard;
